export const SESSION_KEY = 'boostSDSessionId';
export const REQUEST_ID_FILTER_KEY = 'boostSDRequestIdFilterKey';
export const REQUEST_ID_SEARCH_KEY = 'boostSDRequestIdSearchKey';
export const REQUEST_ID_SUGGEST_KEY = 'boostSDRequestIdSuggestKey';
export const REQUEST_ID_SEARCH_TERM_SUGGEST_KEY = 'boostSDRequestIdSearchTermSuggestKey';
export const REQUEST_ID_RECOMMENDATION_KEY = 'boostSDRequestIdRecommendationKey';
export const REQUEST_ID_SAVE_INFO_REQUEST_KEY = 'boostSDRequestIdSaveInfoRequest';
export const REQUEST_ID_MORE_INFORMATION_KEY = 'boostSDRequestIdMoreInformationKey';
export const CLICK_SUGGESTION_KEY = 'boostSDOnClickSuggestion';
